// ============================================================
// Tiny i18n helper. Reads a key from the IT/EN string table and
// interpolates {placeholder} tokens. Keep this dependency-free.
// ============================================================
import type { Lang } from '../data/types';
import { S } from './strings';

/** Get the localised string for `key` in `lang`, with optional {token} interpolation. */
export function t(key: string, lang: Lang, vars?: Record<string, string | number>): string {
  const entry = S[key];
  if (!entry) {
    // In dev this is a useful red flag; in prod we still want graceful behaviour.
    if (import.meta.env.DEV) console.warn(`[i18n] missing key: ${key}`);
    return key;
  }
  const raw = entry[lang];
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (_, k: string) =>
    Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : `{${k}}`,
  );
}

/** Pull both languages of a key (e.g. for raw markup). Rarely needed. */
export function tBoth(key: string) {
  return S[key];
}
